import { useDispatch, useSelector } from "react-redux";
import { updateConfig } from "../../../store/slices/Report/qubriuxOfferSlice";
import { updateConfig as globalUpdateConfig } from "../../../store/slices/Global";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { getQubrixOfferExportedData } from "../api";
import { getFormatedDate } from "../../../utils/Functions/table";
import {
  useGetQubriuxOfferListDataQuery,
  useGetQubriuxOfferBasicListDataQuery,
  useUpdateQubriuxOfferTableHeadDataMutation,
} from "../../../store/queries/Report";

const useQubriuxOffer = () => {
  let paginationOptions = [
    { label: "10 Per page", value: 10 },
    { label: "20 Per page", value: 20 },
    { label: "30 Per page", value: 30 },
  ];
  const dispatch = useDispatch();
  const [isExcelLinkSend, setIsExcelLinkSend] = useState(false);
  const { tableFields, showEditModal } = useSelector((state) => state.global);
  const qubriuxOfferState = useSelector((state) => state.qubriuxOffer);
  const { data: basicData = {} } = useGetQubriuxOfferBasicListDataQuery();

  const {
    data: qubriuxOfferList = {},
    isLoading,
    isFetching,
    refetch,
  } = useGetQubriuxOfferListDataQuery({
    page_size: qubriuxOfferState?.currentPageSize,
    page: qubriuxOfferState?.currentPage,
    search: qubriuxOfferState?.search,
    start_date: getFormatedDate(qubriuxOfferState?.startDate),
    end_date: getFormatedDate(qubriuxOfferState?.endDate),
    customer_key: qubriuxOfferState?.storeId,
    reward_key: qubriuxOfferState?.rewardsId,
  });

  const [updateUserFeedbackFields] = useUpdateQubriuxOfferTableHeadDataMutation();
  const handleSearch = (e) => {
    dispatch(
      updateConfig((state) => {
        state.search = e?.target?.value;
        state.currentPage = 1;
      })
    );
  };
  useEffect(() => {
    if (qubriuxOfferList && qubriuxOfferList?.data?.total_count) {
      dispatch(
        updateConfig((state) => {
          state.totalCount = qubriuxOfferList?.data?.total_count ?? "0";
        })
      );
    }
    //eslint-disable-next-line
  }, [qubriuxOfferList?.data?.total_count]);
  const [date, setDate] = useState({
    startDate: qubriuxOfferState.startDate,
    endDate: qubriuxOfferState.endDate,
    key: "selection",
  });

  const handleClearClick = () => {
    dispatch(updateConfig((state) => (state.search = "")));
  };

  const handleSort = (label) => {
    if (qubriuxOfferState?.sortBy === label) {
      dispatch(
        updateConfig((state) => {
          state.currentPage = 1;
          state.sortOrder =
            qubriuxOfferState?.sortOrder === "asc" ? "desc" : "asc";
        })
      );
    } else {
      dispatch(
        updateConfig((state) => {
          state.currentPage = 1;
          state.sortBy = label;
          state.sortOrder = "asc";
        })
      );
    }
  };

  const handleEditColumnsClick = () => {
    dispatch(
      globalUpdateConfig((state) => {
        state.showEditModal = !state.showEditModal;
      })
    );
  };

  const getRow = (field, data) => {
    const rows = {
      common: (field, data) => <p className="pro-mb-0">{data[field]}</p>,
    };
    return rows?.[field]?.(field, data) ?? rows["common"](field, data);
  };

  const handlePagination = (page) => {
    dispatch(
      updateConfig((state) => {
        state.currentPage = page;
      })
    );
  };

  const handlePageSize = ({ value: page_size }) => {
    dispatch(
      updateConfig((state) => {
        state.currentPageSize = page_size;
        state.currentPage = 1;
      })
    );
  };
  const handleUserFeedbackExcelDownload = () => {
    dispatch(
      updateConfig((state) => {
        state.CardOfferExcelSendModal = !state.CardOfferExcelSendModal;
      })
    );
  };
  const modalClose = () => {
    dispatch(
      updateConfig((state) => {
        state.CardOfferExcelSendModal = false;
      })
    );
  };
  const handleDateChange = (range) => {
    setDate(range);
    dispatch(
      updateConfig((state) => {
        state.currentPage = 1;
        state.startDate = range.startDate;
        state.endDate = range.endDate;
      })
    );
  };
  const handleDateRangeChange = (range) => {
    const startDate = range[0];
    const endDate = range[1];

    setDate({
      startDate,
      endDate,
    });

    dispatch(
      updateConfig((state) => {
        state.currentPage = 1;
        state.startDate = startDate;
        state.endDate = endDate;
      })
    );
  };
  const sendExcelData = async (value) => {
    setIsExcelLinkSend(true);
    let params = {
      email: value?.email ?? "",
      start_date: getFormatedDate(qubriuxOfferState.startDate ?? ""),
      end_date: getFormatedDate(qubriuxOfferState.endDate ?? ""),
      search: qubriuxOfferState?.search,
      customer_key: qubriuxOfferState?.storeId,
      reward_key: qubriuxOfferState?.rewardsId,
    };
    let response = await getQubrixOfferExportedData(params);
    try {
      if (response?.status === 200) {
        toast.success(`Excel download link send successfully`);
      } else {
        toast.error(`Failed to send download link,Please try again`);
      }
    } catch (error) {
      console.error("Failed to send link:", error);
      toast.error(`Failed to send download link`);
    } finally {
      modalClose();
      setIsExcelLinkSend(false);
    }
  };
  const handleChangeStore = (e) => {
    dispatch(
      updateConfig((state) => {
        state.storeId = e?.customer_key;
      })
    );
  };

  const handleChangeReward = (selectedOptions) => {
  const selectedIds = selectedOptions?.map((item) => item.value) || [];
  dispatch(
    updateConfig((state) => {
      state.rewardsId = selectedIds;
    })
  );
};

  let storeList = basicData?.data?.stores?.map((item) => {
    return {
      label: item?.name,
      value: item?._id,
      customer_key: item?.customer_key,
    };
  });
  let rewardsList = basicData?.data?.rewards?.map((item) => {
    return {
      label: item?.reward_key,
      value: item?._id,
    };
  });
  let storeListObj = storeList?.filter(
    (item) => item?.customer_key === qubriuxOfferState?.storeId
  );
  let rewardsListObj = rewardsList?.filter(item => qubriuxOfferState?.rewardsId?.includes(item.value))

  return {
    date,
    storeListObj,
    rewardsListObj,
    isLoading,
    storeList,
    rewardsList,
    isFetching,
    showEditModal,
    isExcelLinkSend,
    paginationOptions,
    qubriuxOfferList,
    qubriuxOfferState,
    handleUserFeedbackExcelDownload,
    updateUserFeedbackFields,
    handleEditColumnsClick,
    handleDateRangeChange,
    handleDateChange,
    handlePagination,
    handleClearClick,
    handlePageSize,
    handleSearch,
    sendExcelData,
    handleChangeStore,
    handleChangeReward,
    handleSort,
    modalClose,
    refetch,
    getRow,
  };
};

export default useQubriuxOffer;
